const isMomentLike = (v: unknown): v is { format: (f: string) => string } =>
    !!v && typeof v === 'object' && typeof (v as { format?: unknown }).format === 'function';

export const normalizeValue = (v: unknown): unknown => {
    if (v === undefined || v === null || v === '') return null;
    if (Array.isArray(v) && v.length === 0) return null;
    if (isMomentLike(v)) return v.format('YYYY-MM-DD');
    if (Array.isArray(v)) return v.map(normalizeValue);
    if (typeof v === 'object') {
        const out: Record<string, unknown> = {};
        for (const [k, val] of Object.entries(v as Record<string, unknown>)) out[k] = normalizeValue(val);
        return out;
    }
    return v;
};

export const normalizeRecord = (r: Record<string, unknown>): Record<string, unknown> => {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(r)) out[k] = normalizeValue(v);
    return out;
};
